// Step 0: portfolio gates checked before any sleeve scans.
const GATES: { title: string; note: string }[] = [
  { title: 'Market open', note: 'NYSE session day (D383)' },
  { title: 'Entry halt cleared', note: 'Policy as of 2026-10-28, not a live read: lifted 2026-09-30 by Marcus and Jeff (D360); it was set 2026-09-14. Lifting a re-imposed halt needs both sign-offs.' },
  { title: 'Not down 4% today', note: 'Daily loss halt (D001)' },
  { title: 'Drawdown ladder', note: '-10 / -15 / -20 / -25% scales size x0.75 / 0.50 / 0.25 / 0' },
  { title: 'Not already owned', note: 'No open position or working buy' },
  { title: 'Sleeve has room', note: 'Deployed below target x regime scalar, and the order fits the D080 per-position cap' },
]

export function GatesStrip() {
  return (
    <section className="strat-section" aria-labelledby="strat-gates-h">
      <h2 id="strat-gates-h" className="strat-h2">Step 0: portfolio gates, every sleeve, every morning</h2>
      <p className="strat-note">
        If any gate says no, no sleeve scans. Executors run 08:00 ETF, 08:05 commodity, 08:10 crypto, 08:15 stock,
        08:30 IPO (EST), before the open, so "today" in the rungs means the last completed session.
      </p>
      <ul className="strat-gates" aria-label="Step 0 portfolio gates">
        {GATES.map(g => (
          <li className="strat-gate" key={g.title}>
            <b>{g.title}</b>
            <small>{g.note}</small>
          </li>
        ))}
      </ul>
    </section>
  )
}
